<div class="modal-container request-new-delivery-modal-container">
  <div class="modal-content">
    <div class="modal-header d-flex align-items-center">
      <h4 class="modal-title">{{ 'personalInfo.requestNewDeliveryAddr.title' | cxTranslate }}</h4>
      <button class="btn btn-link p-0 my-auto border-0 ml-auto close" aria-label="Close" (click)="closeModal('close')">
        <mat-icon svgIcon="modal-x-icon"></mat-icon>
      </button>
    </div>
    <div class="modal-body">
      <app-dynamic-form
        (formGroupEmit)="updateFormGroup($event)"
        (formModelEmit)="updateFormModel($event)"
        [formGroupId]="'REQUEST_DELIVERY_ADDRESS'"
        [static]="false"
        [formChange]="true"
        [emitOnInit]="true"
        [fieldChange]="'deliveryCountry'"
      ></app-dynamic-form>
    </div>
    <div class="modal-footer justify-content-sm-between justify-content-md-end">
      <button type="button" class="btn secondary-btn" (click)="closeModal('close')">
        {{ 'personalInfo.requestNewDeliveryAddr.cancelBtn' | cxTranslate }}
      </button>
      <button
        type="button"
        class="btn primary-btn"
        [class.desktop]="isDesktop"
        [class.disabled]="isDisabled"
        [disabled]="isDisabled"
        (click)="onSubmitReuestDeliveryAddrForm()"
      >
        @if (isDesktop) {
        {{ 'personalInfo.requestNewDeliveryAddr.title' | cxTranslate }}
        } @else {
        {{ 'personalInfo.requestNewDeliveryAddr.submitBtn' | cxTranslate }}
        }
      </button>
    </div>
  </div>
</div>
